import axios from 'axios';
import { getAuth } from '../../modules/auth';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
});

axiosInstance.interceptors.request.use((config) => {
  const auth = getAuth();
  if (auth?.token) {
    if (config.headers) {
      config.headers.Authorization = `Bearer ${auth.token}`;
    }
  }
  return config;
});

export default axiosInstance;
